import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, onSnapshot, updateDoc, deleteDoc, doc, query, orderBy, getCountFromServer, limit, getDocs } from 'firebase/firestore';
import { db } from '../LoginComp/firebase';



import jsPDF from 'jspdf';
import "./community.css";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend,
  PieChart, Pie, Cell,
  LineChart, Line
} from "recharts";
import html2canvas from "html2canvas";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];





const ADMIN_PASSWORD = "Ec@2007"; // change as needed

function AdminPanelOptical() {
  const [activeSubMenu, setActiveSubMenu] = useState('createVoucher');
  const [vouchers, setVouchers] = useState([]);
  const [editingVoucher, setEditingVoucher] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nextVoucherNumber, setNextVoucherNumber] = useState('001');
  const navigate = useNavigate();

const [showPasswordModal, setShowPasswordModal] = useState(false);
const [passwordInput, setPasswordInput] = useState("");
const [pendingDate, setPendingDate] = useState("");
const [pendingAction, setPendingAction] = useState(null); // "edit" | "delete" | "date"
const [pendingVoucher, setPendingVoucher] = useState(null);

    const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    year: "",
    month: "",
    branch: "",
    paymentMethod: ""
  });

  const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters({ ...filters, [name]: value });
};




  // Form state
const [formData, setFormData] = useState({
  branch: 'Maradana',
  description: '',
  amount: '',
  typeOfExpenses: '',
  paymentMethod: 'Cash',
  chequeNumber: '',
  depositNumber: '',
  date: new Date().toISOString().split('T')[0],
  preparedBy: '',
  authorizedBy: ''
});

  // Get the next voucher number from Firestore
// Get the next voucher number (based on the highest existing voucherNumber)
useEffect(() => {
  const getNextVoucherNumber = async () => {
    try {
      const q = query(
        collection(db, "asianpolytechnic_vouchers"),
        orderBy("voucherNumber", "desc"),
        limit(1)
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const lastVoucher = snapshot.docs[0].data();
        const nextNumber = (parseInt(lastVoucher.voucherNumber, 10) + 1)
          .toString()
          .padStart(3, "0");
        setNextVoucherNumber(nextNumber);
      } else {
        setNextVoucherNumber("001"); // first voucher
      }
    } catch (error) {
      console.error("Error getting next voucher number:", error);
      setNextVoucherNumber("001");
    }
  };

  getNextVoucherNumber();
}, [vouchers]);





  // Load vouchers from Firestore
  useEffect(() => {
    setLoading(true);
    const q = query(collection(db, 'asianpolytechnic_vouchers'), orderBy('createdAt', 'desc'));
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const vouchersData = [];
      querySnapshot.forEach((doc) => {
        vouchersData.push({ id: doc.id, ...doc.data() });
      });
      setVouchers(vouchersData);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching vouchers:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      branch: 'Colombo 08',
      description: '',
      amount: '',
      typeOfExpenses: '',
      paymentMethod: 'Cash',
      chequeNumber: '',
      depositNumber: '',
      date: new Date().toISOString().split('T')[0],
      preparedBy: '',
      authorizedBy: ''
    });
    setEditingVoucher(null);
  };

  // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
    
//     try {
//       let voucherData = {
//         ...formData,
//         voucherNumber: editingVoucher ? editingVoucher.voucherNumber : nextVoucherNumber,
//         createdAt: editingVoucher ? editingVoucher.createdAt : new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//       };

//       if (editingVoucher) {
//         // Update existing voucher
//         await updateDoc(doc(db, 'optical_vouchers', editingVoucher.id), voucherData);
//       } else {
//         // Add new voucher
//         const docRef = await addDoc(collection(db, 'optical_vouchers'), voucherData);
//         voucherData.id = docRef.id;
        
//         // Generate PDF after creating voucher
//         generatePDF(voucherData);
//       }



//       resetForm();
// setLoading(false);

// // Force refresh view after creating
// setActiveSubMenu("viewVouchers");
// setTimeout(() => setActiveSubMenu("createVoucher"), 500);

//     } catch (error) {
//       console.error('Error saving voucher:', error);
//       setLoading(false);
//     }
//   };
// Get the next voucher number (based on the highest existing voucherNumber)

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    let voucherNumber;

    if (editingVoucher) {
      voucherNumber = editingVoucher.voucherNumber;
    } else {
      // Always use the latest "nextVoucherNumber"
      voucherNumber = nextVoucherNumber;
    }

    let voucherData = {
      ...formData,
      voucherNumber,
      createdAt: editingVoucher ? editingVoucher.createdAt : new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    if (editingVoucher) {
      await updateDoc(doc(db, "asianpolytechnic_vouchers", editingVoucher.id), voucherData);
    } else {
      const docRef = await addDoc(collection(db, "asianpolytechnic_vouchers"), voucherData);
      voucherData.id = docRef.id;

      // Generate PDF after creating voucher
      generatePDF(voucherData);

      // ✅ Immediately bump the nextVoucherNumber in state
      setNextVoucherNumber(
        (parseInt(voucherNumber, 10) + 1).toString().padStart(3, "0")
      );
    }

    resetForm();
    setLoading(false);

    // Switch views briefly to refresh UI
    setActiveSubMenu("viewVouchers");
    setTimeout(() => setActiveSubMenu("createVoucher"), 500);
  } catch (error) {
    console.error("Error saving voucher:", error);
    setLoading(false);
  }
};







const downloadChartAsPDF = (id, filename) => {
  const chartElement = document.getElementById(id);
  if (!chartElement) return;
  html2canvas(chartElement).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");
    const imgWidth = 280;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
    pdf.save(filename);
  });
};












// Edit voucher (open modal)
const handleEditRequest = (voucher) => {
  setPendingAction("edit");
  setPendingVoucher(voucher);
  setShowPasswordModal(true);
};

// Delete voucher (open modal)
const handleDeleteRequest = (voucher) => {
  setPendingAction("delete");
  setPendingVoucher(voucher);
  setShowPasswordModal(true);
};

// Generate PDF
const generatePDF = (voucher) => {
  // Create A5 landscape document (210 x 148 mm)
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a5'
  });
  
  // Add background for header
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, 210, 25, 'F');
  
  // Add logo (assuming it's in the public folder)
  try {
    // This would work if we were in a browser environment with the image available
    // For now, we'll use text as a fallback
    doc.addImage('/asianpolytechnic_logo.png', 'PNG', 15, 3, 20, 20);
  } catch (e) {
    // If image fails to load, use text logo
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.text("◆", 20, 12);
  }
  
  // Add company name
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.text("Asian Polytechnic Campus", 105, 12, { align: 'center' });
  
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  doc.text("No. 932, Maradana Road, Colombo 08", 105, 18, { align: 'center' });
  doc.text("Tel: 011 268 2277 / 077 344 0937", 105, 24, { align: 'center' });

  // Divider line
  doc.setDrawColor(200, 200, 200);
  doc.line(15, 45, 195, 45);
  
  // Voucher details
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text(`Voucher Number: ${voucher.voucherNumber}`, 20, 55);
  doc.text(`Branch: ${voucher.branch}`, 80, 55);
  doc.text(`Date: ${voucher.date}`, 120, 55);
  doc.text(`Type Of Expenses: ${voucher.typeOfExpenses}`, 120, 62);

  // Payment Method with extra info
  let paymentDetails = `Payment Method: ${voucher.paymentMethod}`;
  if (voucher.paymentMethod === "Cheque" && voucher.chequeNumber) {
    paymentDetails += ` (No: ${voucher.chequeNumber})`;
  }
  if (voucher.paymentMethod === "Direct Deposit" && voucher.depositNumber) {
    paymentDetails += ` (No: ${voucher.depositNumber})`;
  }

  doc.text(paymentDetails, 20, 62);

  // Table header
  doc.setFillColor(240, 240, 240);
  doc.rect(15, 70, 180, 8, 'F');
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Description", 20, 75);
  doc.text("Amount (Rs.)", 160, 75, { align: 'right' });
  
  // Table content - Handle long descriptions with auto-wrap
  doc.setFont("helvetica", "normal");
  
  // Split description into multiple lines if it's too long
  const maxDescriptionWidth = 120; // Maximum width for description column in mm
  const descriptionLines = doc.splitTextToSize(voucher.description, maxDescriptionWidth);
  
  // Calculate starting Y position for description
  let descriptionY = 85;
  const lineHeight = 5; // Approximate line height in mm
  
  // Draw description as multiple lines if needed
  doc.text(descriptionLines, 20, descriptionY);
  
  // Calculate the height of the description block
  const descriptionHeight = descriptionLines.length * lineHeight;
  
  // Position amount vertically aligned with the description
  const amountY = descriptionLines.length > 1 
    ? descriptionY + (descriptionHeight / 2) - 2  // Center for multi-line
    : descriptionY;  // Normal position for single line
  
  doc.text(parseFloat(voucher.amount).toLocaleString('en-US', { 
    minimumFractionDigits: 2 
  }), 160, amountY, { align: 'right' });
  
  // Adjust total row position based on description height
  const totalStartY = Math.max(95, descriptionY + descriptionHeight + 5);
  
  // Total row
  doc.setDrawColor(200, 200, 200);
  doc.line(15, totalStartY, 195, totalStartY);
  
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Total Amount", 20, totalStartY + 7);
  doc.text(`Rs. ${parseFloat(voucher.amount).toLocaleString('en-US', { 
    minimumFractionDigits: 2 
  })}`, 160, totalStartY + 7, { align: 'right' });
  
  // Adjust signatures section position
  const signaturesY = totalStartY + 15;
  
  // Signatures section
  doc.setDrawColor(200, 200, 200);
  doc.line(15, signaturesY, 195, signaturesY);
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Prepared By", 40, signaturesY + 10);
  doc.text("Recieved By", 140, signaturesY + 10);
  
  doc.setFont("helvetica", "normal");
  doc.text(voucher.preparedBy, 40, signaturesY + 18);
  doc.text(voucher.authorizedBy, 140, signaturesY + 18);
  
  // Signature lines
  doc.setDrawColor(100, 100, 100);
  doc.line(30, signaturesY + 22, 80, signaturesY + 22);
  doc.line(130, signaturesY + 22, 180, signaturesY + 22);
  
  // Adjust footer position
  const footerY = signaturesY + 30;
  
  // Footer - only show if there's enough space (A5 landscape height is 148mm)
  if (footerY < 145) {
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("Thank you for your business!", 105, footerY, { align: 'center' });
  }
  
  // Save the PDF
  doc.save(`voucher_${voucher.voucherNumber}.pdf`);
};
  // Function to handle logout
  const handleLogout = () => {
    navigate('/');
  };




const filteredVouchers = vouchers.filter((v) => {
  const voucherDate = new Date(v.date);
  const voucherYear = voucherDate.getFullYear().toString();
  const voucherMonth = (voucherDate.getMonth() + 1).toString().padStart(2, "0");

  return (
    (!filters.year || filters.year === voucherYear) &&
    (!filters.month || filters.month === voucherMonth) &&
    (!filters.branch || filters.branch === v.branch) &&
    (!filters.paymentMethod || filters.paymentMethod === v.paymentMethod)
  );
});







  // Render main content based on active submenu
  const renderMainContent = () => {
    switch(activeSubMenu) {
      case 'createVoucher':
        return (
          <div className="content-section">
            <h2>{editingVoucher ? 'Edit Voucher' : 'Create Voucher'}</h2>
            <div className="voucher-number-display">
              Voucher Number: {editingVoucher ? editingVoucher.voucherNumber : nextVoucherNumber}
            </div>
            <form className="form-container" onSubmit={handleSubmit}>
              <div className="form-row">

              <div className="input-group">
                  <label>Branch *</label>
                  <select 
                    name="branch"
                    value={formData.branch}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="Colombo 08">Colombo 08</option>
                    <option value="Colombo 07">Colombo 07</option>
                    <option value="Other">Other</option>
                  </select>
                </div>


                <div className="input-group">
                  <label>Description *</label>
                  <input 
                    type="text" 
                    name="description"
                    placeholder="Enter description" 
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="input-group">
                  <label>Amount (Rs.) *</label>
                  <input 
                    type="number" 
                    name="amount"
                    placeholder="Enter amount" 
                    value={formData.amount}
                    onChange={handleInputChange}
                    required
                    step="0.01"
                    min="0"
                  />
                </div>




<div className="input-group">
  <label>Type Of Expenses *</label>
  <select
    name="typeOfExpenses"
    value={formData.typeOfExpenses}
    onChange={handleInputChange}
    required
  >
    <option value="">-- Select Expense Type --</option>
    <option value="Academic Event Expenses">Academic Event Expenses</option>
    <option value="Academic Expenses">Academic Expenses</option>
    <option value="Accesories Payments">Accesories Payments</option>
    <option value="Accounting fee">Accounting fee</option>
    <option value="Assesor Payment">Assesor Payment</option>
    <option value="Building Payment">Building Payment</option>
    <option value="Cash Withdrawal">Cash Withdrawal</option>
    <option value="Construction Works">Construction Works</option>
    <option value="Consultation">Consultation</option>
    <option value="Courier & Postages">Courier & Postages</option>
    <option value="Electricty-ECI">Electricty-ECI</option>
    <option value="Electricty-Ward place">Electricty-Ward place</option>
    <option value="EPF Payments">EPF Payments</option>
    <option value="ETF Payments">ETF Payments</option>
    <option value="Foods & Meals">Foods & Meals</option>
    <option value="Income Tax Payment">Income Tax Payment</option>
    <option value="Lecture Payment">Lecture Payment</option>
    <option value="Printing & Stationary">Printing & Stationary</option>
    <option value="Promotion">Promotion</option>
    <option value="Rent">Rent</option>
    <option value="Repair & Maintanance">Repair & Maintanance</option>
    <option value="Salaries & Wages">Salaries & Wages</option>
    <option value="Scholarship Expenses">Scholarship Expenses</option>
    <option value="Suppliers Payment">Suppliers Payment</option>
    <option value="Telephone Bill">Telephone Bill</option>
    <option value="Training & Development">Training & Development</option>
    <option value="Travelling & Transport">Travelling & Transport</option>
    <option value="Water Bill">Water Bill</option>
    <option value="WHT for Eye care Institute Rent">WHT for Eye care Institute Rent</option>
    <option value="Others">Others</option>
  </select>
</div>




              </div>
              














       <div className="form-row">
  <div className="input-group">
    <label>Payment Method *</label>
    <select
      name="paymentMethod"
      value={formData.paymentMethod}
      onChange={handleInputChange}
      required
    >
      <option value="Cash">Cash</option>
         <option value="Card">Card</option>
      <option value="Cheque">Cheque</option>
      <option value="Direct Deposit">Direct Deposit</option>
      <option value="Other">Other</option>
    </select>
  </div>

  {formData.paymentMethod === "Cheque" && (
    <div className="input-group">
      <label>Cheque Number *</label>
      <input
        type="text"
        name="chequeNumber"
        value={formData.chequeNumber}
        onChange={handleInputChange}
        required
      />
    </div>
  )}

  {formData.paymentMethod === "Direct Deposit" && (
    <div className="input-group">
      <label>Deposit Number *</label>
      <input
        type="text"
        name="depositNumber"
        value={formData.depositNumber}
        onChange={handleInputChange}
        required
      />
    </div>
  )}







            <div className="input-group">
              <label>Date *</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={(e) => {
                    const today = new Date().toISOString().split("T")[0];
                    if (e.target.value < today) {
                      setPendingAction("date");
                      setPendingDate(e.target.value);
                      setShowPasswordModal(true);
                      return;
                    }
                    handleInputChange(e); // normal case
                  }}
                  required />
                 </div>
              </div>

              
              <div className="form-row">
                <div className="input-group">
                  <label>Prepared By *</label>
                  <input 
                    type="text" 
                    name="preparedBy"
                    placeholder="Enter name" 
                    value={formData.preparedBy}
                    onChange={handleInputChange}
       
                  />
                </div>
                <div className="input-group">
                  <label>Authorized By *</label>
                  <input 
                    type="text" 
                    name="authorizedBy"
                    placeholder="Enter name" 
                    value={formData.authorizedBy}
                    onChange={handleInputChange}
           
                  />
                </div>
              </div>
              
              <div className="form-buttons">
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? 'Saving...' : (editingVoucher ? 'Update Voucher' : 'Create Voucher & Download PDF')}
                </button>
                {editingVoucher && (
                  <button 
                    type="button" 
                    className="cancel-btn"
                    onClick={resetForm}
                    disabled={loading}
                  >
                    Cancel Edit
                  </button>
                )}
              </div>
            </form>
          </div>
        );
      case 'viewVouchers':
        return (

<div className="content-section">
  <h2>View All Vouchers</h2>

  {/* Filter Section */}
  <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
    <i className="fas fa-filter"></i> {showFilters ? "Hide Filters" : "Show Filters"}
  </button>

  {showFilters && (
    <div className="filter-section">
      <select name="year" value={filters.year} onChange={handleFilterChange}>
        <option value="">All Years</option>
        {Array.from({ length: 10 }, (_, i) => {
          const year = new Date().getFullYear() - i;
          return <option key={year} value={year}>{year}</option>;
        })}
      </select>

      <select name="month" value={filters.month} onChange={handleFilterChange}>
        <option value="">All Months</option>
        {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m,i) => (
          <option key={i} value={m}>{new Date(0, i).toLocaleString('default',{month:'long'})}</option>
        ))}
      </select>

      <select name="branch" value={filters.branch} onChange={handleFilterChange}>
        <option value="">All Branches</option>
        <option value="Colombo 08">Colombo 08</option>
        <option value="Colombo 07">Colombo 07</option>
        <option value="Other">Other</option>
      </select>

      <select name="paymentMethod" value={filters.paymentMethod} onChange={handleFilterChange}>
        <option value="">All Methods</option>
        <option value="Cash">Cash</option>
         <option value="Card">Card</option>
        <option value="Cheque">Cheque</option>
        <option value="Direct Deposit">Direct Deposit</option>
        <option value="Other">Other</option>
      </select>

      {/* Reset Button */}
      <button
        className="reset-btn"
        onClick={() =>
          setFilters({
            year: "",
            month: "",
            branch: "",
            paymentMethod: "",
          })
        }
      >
        <i className="fas fa-undo"></i> Reset Filters
      </button>


      <button className="export-btn" onClick={exportToExcel}>
        <i className="fas fa-file-excel"></i> Export Excel
      </button>
    </div>
  )}



            {loading ? (
              <p>Loading vouchers...</p>
            ) : vouchers.length === 0 ? (
              <p>No vouchers found. Create your first voucher.</p>
            ) : (
              <div className="table-container">
                <table>
                  <thead>
                    <tr>

                      <th>Voucher Number</th>
                      <th>Branch</th>
                      <th>Description</th>
                      <th>Amount (Rs.)</th>
                      <th>Date</th>
                      <th>Payment Method</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
  {filteredVouchers.map((voucher) => (
    <tr key={voucher.id}>
      <td className="voucher-number">{voucher.voucherNumber}</td>
      <td>{voucher.branch}</td>
      <td>{voucher.description}</td>
      <td className="amount">
        {parseFloat(voucher.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}
      </td>
      <td>{voucher.date}</td>
      <td>{voucher.paymentMethod}</td>
      <td>
        <div className="action-buttons">



<button 
  className="action-btn edit-btn"
  onClick={() => handleEditRequest(voucher)}
>
  <i className="fas fa-edit"></i> Edit
</button>

<button 
  className="action-btn delete-btn"
  onClick={() => handleDeleteRequest(voucher)}
>
  <i className="fas fa-trash"></i> Delete
</button>



          <button 
            className="action-btn download-btn"
            onClick={() => generatePDF(voucher)}
          >
            <i className="fas fa-download"></i> PDF
          </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>
                
                </table>
              </div>
            )}
          </div>
        );




case "analysis": {
  // Group vouchers by month-year → then group by type
  const monthlyTypeData = {};
  vouchers.forEach((v) => {
    const d = new Date(v.date);
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();
    const key = `${month}-${year}`;

    if (!monthlyTypeData[key]) monthlyTypeData[key] = {};
    monthlyTypeData[key][v.typeOfExpenses] =
      (monthlyTypeData[key][v.typeOfExpenses] || 0) + parseFloat(v.amount || 0);
  });

  // Convert to chart-friendly format
  const monthlyPieCharts = Object.entries(monthlyTypeData).map(([monthYear, types]) => {
    const pieData = Object.entries(types).map(([name, value]) => ({
      name,
      value,
    }));
    return { monthYear, pieData };
  });

  // Yearly Line chart (same as before)
  const yearlyData = {};
  vouchers.forEach((v) => {
    const d = new Date(v.date);
    const year = d.getFullYear();
    yearlyData[year] = (yearlyData[year] || 0) + parseFloat(v.amount || 0);
  });
  const yearlyChartData = Object.entries(yearlyData).map(([y, amt]) => ({
    year: y,
    amount: amt,
  }));

  return (
    <div className="content-section">
      <h2>Analysis Report</h2>

      {/* Month-wise Pie Charts */}
      {monthlyPieCharts.map(({ monthYear, pieData }, idx) => (
        <details key={idx} className="month-section" open={idx === monthlyPieCharts.length - 1}>
          <summary className="month-title">{monthYear} Expenses by Type</summary>
          <div id={`pieChart-${monthYear}`} style={{ textAlign: "center", marginBottom: "20px" }}>
            <PieChart width={700} height={400}>
              <Pie
                data={pieData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                fill="#8884d8"
                label
              >
                {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
            <button
              onClick={() => downloadChartAsPDF(`pieChart-${monthYear}`, `${monthYear}-expenses.pdf`)}
            >
              Download PDF
            </button>
          </div>
        </details>
      ))}

      {/* Yearly Line Chart */}
      <div id="yearlyChart" style={{ textAlign: "center", marginTop: "30px" }}>
        <h3>Yearly Expenses Trend</h3>
        <LineChart width={700} height={300} data={yearlyChartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="amount" stroke="#82ca9d" />
        </LineChart>
        <button
          onClick={() => downloadChartAsPDF("yearlyChart", "yearly-expenses.pdf")}
        >
          Download PDF
        </button>
      </div>
    </div>
  );
}







      default:
        return (
          <div className="content-section welcome">
            <h2>Welcome to Asian Poly Technic Campus Admin Panel</h2>
            <p>Select an option from the sidebar to manage vouchers.</p>
          </div>
        );
    }
  };









const exportToExcel = () => {
  if (!vouchers || vouchers.length === 0) return;

  // Map vouchers into desired column order
  const formattedData = vouchers.map(v => ({
    "Date": v.date, 
    "Voucher Number": v.voucherNumber,
    "description": v.description,
    "Type Of Expenses": v.typeOfExpenses,
    "Description": v.description,
    "Amount (Rs.)": v.amount,
    "Payment Method": v.paymentMethod,
    "Cheque Number": v.chequeNumber,
  }));




  


  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Vouchers");

  // Export
  XLSX.writeFile(workbook, "Vouchers.xlsx");
};






  return (
    <div className="admin-panel-institute">
      <div className="top-nav">
        <div className="nav-buttons">
          <button 
            className={activeSubMenu === 'createVoucher' ? 'active' : ''}
            onClick={() => setActiveSubMenu('createVoucher')}
          >
            <i className="fas fa-plus-circle"></i> Create Voucher - Asian Polytechnic Campus
          </button>
          <button 
            className={activeSubMenu === 'viewVouchers' ? 'active' : ''}
            onClick={() => setActiveSubMenu('viewVouchers')}
          >
            <i className="fas fa-list"></i> View All Vouchers
          </button>

                             <button 
            className={activeSubMenu === 'analysis' ? 'active' : ''}
            onClick={() => setActiveSubMenu('analysis')}
          >
            <i className="fas fa-list"></i>Analysis Report
          </button>

          
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i> Logout
        </button>


        {showPasswordModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h3>Enter Admin Password</h3>
      <input
        type="password"
        value={passwordInput}
        onChange={(e) => setPasswordInput(e.target.value)}
        placeholder="Password"
      />
      <div className="modal-actions">
<button
  onClick={async () => {
    if (passwordInput === ADMIN_PASSWORD) {
      if (pendingAction === "date") {
        handleInputChange({ target: { name: "date", value: pendingDate } });
      } else if (pendingAction === "edit" && pendingVoucher) {
        setEditingVoucher(pendingVoucher);
        setFormData({
          branch: pendingVoucher.branch || "Colombo 08",
          description: pendingVoucher.description,
          amount: pendingVoucher.amount,
          paymentMethod: pendingVoucher.paymentMethod,
          date: pendingVoucher.date,
          preparedBy: pendingVoucher.preparedBy,
          authorizedBy: pendingVoucher.authorizedBy,
        });
        setActiveSubMenu("createVoucher");
      } else if (pendingAction === "delete" && pendingVoucher) {
        if (window.confirm("Are you sure you want to delete this voucher?")) {
          try {
            await deleteDoc(doc(db, "asianpolytechnic_vouchers", pendingVoucher.id));
          } catch (error) {
            console.error("Error deleting voucher:", error);
          }
        }
      }

      // ✅ Reset modal
      setShowPasswordModal(false);
      setPasswordInput("");
      setPendingAction(null);
      setPendingVoucher(null);
      setPendingDate("");
    } else {
      alert("Wrong Password!!!");
    }
  }}
>
  Confirm
</button>
        <button
          onClick={() => {
            setShowPasswordModal(false);
            setPasswordInput("");
            setPendingDate("");
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

      </div>
      
      <div className="main-content">
        {renderMainContent()}
      </div>
    </div>
  );
}




export default AdminPanelOptical